module.exports = __webpack_public_path__ + "img/blog_menu_pic11.afb11430.png";